const transformText = require('./transformText')

const updateNameAtDescription = ({genderId, description, name}) => transformText(genderId)(description)
  .replace(new RegExp('★СУЩЕСТВО★', 'g'), `*${name}*`)
  .replace(new RegExp('★ТРАНСПОРТ★', 'g'), `*${name}*`)

module.exports = updateNameAtDescription
